// Single source of truth for the post-purchase funnel.
//
// FUNNEL_LADDER is the ordered chain of upsell offers shown after ANY
// initial purchase (or after passing on any prior step). Each entry
// optionally carries a `downsell` tier — the payment-plan / lower-friction
// alternative shown alongside the main upsell button.

export const FUNNEL_LADDER = [
  { tier: "suite" },
  { tier: "vip" },
  { tier: "cohort", downsell: "cohort_plan" },
  { tier: "dfy", downsell: "dfy_plan" },
];

// Map any tier_id (purchase-success or pass-from) to its position in the ladder
// so the next step can be resolved. -1 means "after the ladder" (terminal).
const POSITION = {
  // Initial purchases land BEFORE these ladder positions
  studio: 0,        // → next offer is suite
  suite: 1,         // → next offer is vip
  vip: 2,           // → next offer is cohort
  cohort: 3,        // → next offer is dfy
  dfy: 4,           // → past the ladder, goes to summary
  // Plans are terminal
  cohort_plan: 4,
  dfy_plan: 4,
};

/**
 * Given the tier the user just purchased OR passed on, return either:
 *   { nextTier, downsell }   — show the next funnel offer
 *   { done: true }           — funnel complete, route to /order-summary
 */
export function nextFunnelStep(fromTier) {
  const idx = POSITION[fromTier];
  if (idx === undefined || idx >= FUNNEL_LADDER.length) return { done: true };
  const step = FUNNEL_LADDER[idx];
  return { nextTier: step.tier, downsell: step.downsell || null };
}

/**
 * Given a "next" tier id (the one we're about to display), look up its downsell.
 * Used when the user lands on `/checkout/success?next=cohort` and we need to
 * also show the cohort_plan downsell button.
 */
export function downsellFor(tierId) {
  const step = FUNNEL_LADDER.find((s) => s.tier === tierId);
  return step?.downsell || null;
}
